<template lang="html">

  <section class="wrapper legal">
    <div class="container">

      <h1>Política de privacidad</h1>

      <h2>Politica de privacidad</h2>

      <h3>Olitica de privacidad</h3>

      <p>Lorem, ipsum dolor sit amet consectetur adipisicing elit. Voluptatum fugit et ratione reiciendis molestiae. Tempora aut ex porro possimus, vitae non magnam autem facere deleniti dicta ipsam a animi voluptas!</p>

      <ul>
        <li>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Laudantium dolor fugiat error veritatis autem vitae consequuntur obcaecati similique veniam molestias cumque quod quidem, saepe nobis corporis aliquam blanditiis nesciunt deleniti?</li>
        <li>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Laudantium dolor fugiat error veritatis autem vitae consequuntur obcaecati similique veniam molestias cumque quod quidem, saepe nobis corporis aliquam blanditiis nesciunt deleniti?</li>
        <li>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Laudantium dolor fugiat error veritatis autem vitae consequuntur obcaecati similique veniam molestias cumque quod quidem, saepe nobis corporis aliquam blanditiis nesciunt deleniti?</li>
        <li>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Laudantium dolor fugiat error veritatis autem vitae consequuntur obcaecati similique veniam molestias cumque quod quidem, saepe nobis corporis aliquam blanditiis nesciunt deleniti?</li>
        <li>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Laudantium dolor fugiat error veritatis autem vitae consequuntur obcaecati similique veniam molestias cumque quod quidem, saepe nobis corporis aliquam blanditiis nesciunt deleniti?</li>
      </ul>



    </div>
  </section>

</template>

<script lang="js">
  export default  {
    name: 'politica-de-privacidad',
}
</script>




// WEBPACK FOOTER //
// src/components/views/politica-de-privacidad.vue